import React, { useEffect, useState } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import LandingPageComponent from "../../Components/LandingPageComponent/LandingPageComponent";
import OurExclusivePartner from "../../Components/OurExclusivePartner/OurExclusivePartner";
import {
  Apiurl,
  GetLocalStorageParsed,
  parseData,
  stringifyData,
} from "../utils/page";
import axios from "axios";
import Loader from "../../Components/Loader/Loader";

const LandingPage = () => {
  const FetchToken = GetLocalStorageParsed("AuthToken");
  const [loading, setLoading] = useState("");
  const [loginTokenda, setLoginTokenda] = useState(FetchToken || null);
    const [loginToken, setLoginToken] = useState(FetchToken || null);
  
  const [categoriesData, setcategoriesData] = useState();
  const [dataByCategory, setDataByCategory] = useState();
  const [bidAndDealProducts, setBidAndDealProducts] = useState();
  const [categorySelected,setCategorySelected]=useState();


  const handleGetCategory = () => {
    const option = {
      method: "Get",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginTokenda}`,
      },
      url: `${Apiurl()}/api/Product/GetAllCategories`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e.data.result);
        setcategoriesData(data);
      })
      .catch((error) => {});
  };
  const handleGetExpiringBidsAndBestDealsProducts = () => {
    const option = {
      method: "Get",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginTokenda}`,
      },
      url: `${Apiurl()}/api/Product/GetExpiringBidsAndBestDealsProducts`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e.data.result);
        setBidAndDealProducts(data);
        setLoading("");
      })
      .catch((error) => {});
  };
  useEffect(() => {
    handleGetCategory();
    handleGetExpiringBidsAndBestDealsProducts();
  }, []);

  const handleCategorySelect = (i) => {
    setLoading("category");
    setCategorySelected(i);
    const data = {
      Id: i?.Id,
    };
    const option = {
      method: "Post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginTokenda}`,
      },
      url: `${Apiurl()}/api/Product/GetProductsByCategories`,
      data: stringifyData(data),
    };
    axios(option)
      .then((e) => {
        const data = parseData(e.data.result);
        setDataByCategory(data);
        setLoading("");
      })
      .catch((error) => {});
  };
  return (
    <div
      style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
    >
      {loading === "banner"  ? (
        <div className="loading-container">
          <Loader />
        </div>
      ) : null}
      <Header 
        setLoginToken={setLoginToken}
        />
      <OurExclusivePartner setLoading={setLoading} />

      <LandingPageComponent
        categoriesData={categoriesData}
        bidAndDealProducts={bidAndDealProducts}
        handleCategorySelect={handleCategorySelect}
        categorySelected={categorySelected}
        dataByCategory={dataByCategory}
        loading={loading}
        setCategorySelected={setCategorySelected}
      />

      <Footer />
    </div>
  );
};

export default LandingPage;
